import styled, { css, keyframes } from "styled-components";
import { devices } from "../../Devices";
import { Input } from "../sharable/InputStyle";

export const PageWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: #fff;
`;

export const CompactHeader = styled.header`
  display: flex;
  justify-content: center;
  padding: 1.6rem 2.4rem;
  margin-bottom: 1.6rem;
  @media ${devices.tablet} {
    justify-content: flex-start;
  }
`;

export const MainGrid = styled.main`
  display: grid;
  grid-template-columns: 1fr;
  gap: 4.8rem;
  max-width: 128rem;
  margin: 0 auto;
  padding: 0 2.4rem 4.8rem;

  @media ${devices.mobileL} {
    padding: 0 1.6rem 3.6rem;
    gap: 3.6rem;
  }

  @media (min-width: 1025px) {
    grid-template-columns: 1.1fr 0.9fr;
    align-items: start;
    gap: 6rem;
    padding: 0 4.8rem 6rem;
  }
`;

export const MarketingColumn = styled.section`
  display: flex;
  flex-direction: column;
  gap: 3.2rem;
`;

export const FormColumn = styled.aside`
  @media (min-width: 1025px) {
    position: sticky;
    top: 2.4rem;
  }
`;

export const HeroHeading = styled.h1`
  font-size: 3.2rem;
  line-height: 1.15;
  font-weight: 800;
  text-transform: uppercase;
  color: #181818;

  span {
    color: #d97706;
  }

  @media ${devices.mobileL} {
    font-size: 2.6rem;
    text-align: center;
    text-align: left;
  }

  @media (min-width: 1025px) {
    font-size: 4.2rem;
  }
`;

export const HeroSubtext = styled.p`
  font-size: 1.6rem;
  color: #444;
  max-width: 52rem;
  margin-top: 1rem;
  @media ${devices.mobileL} {
    font-size: 1.4rem;
    text-align: center;
    line-height: 1.1;
  }
`;

export const HeroCtaWrapper = styled.div`
  margin-top: 2.4rem;
  @media ${devices.mobileL} {
    display: flex;
    justify-content: center;
  }
`;

export const StepsTitle = styled.h2`
  font-size: 2rem;
  font-weight: 700;
  color: #181818;
  text-transform: uppercase;

  @media ${devices.mobileL} {
    font-size: 1.7rem;
    text-align: center;
  }
`;

export const StepsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.6rem;
  margin-top: 1.6rem;

  @media ${devices.mobileL} {
    grid-template-columns: 1fr;
  }
`;

export const StepCard = styled.div`
  background-color: #fafafa;
  border: 1px solid rgba(1, 1, 1, 0.08);
  border-radius: 12px;
  padding: 2rem 1.6rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.8rem;
  transition: transform 200ms ease-in-out;

  &:hover {
    transform: translateY(-4px);
  }

  h3 {
    font-size: 1.5rem;
    font-weight: 700;
    text-transform: uppercase;
  }

  p {
    font-size: 1.3rem;
    color: #555;
  }
`;

export const StepTopRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const StepNumber = styled.span`
  font-size: 1.3rem;
  font-weight: 800;
  color: #d97706;
`;

export const StepIcon = styled.div`
  width: 3.6rem;
  height: 3.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ icon }) =>
    icon &&
    css`
      background-image: url("${icon}");
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    `}
`;

export const ConversionBlock = styled.div`
  background-color: #fff7ec;
  border: 1px solid #f3d9b1;
  border-radius: 12px;
  padding: 2.4rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.2rem;

  h2 {
    font-size: 1.9rem;
    font-weight: 800;
    text-transform: uppercase;
    color: #181818;
  }

  p {
    font-size: 1.3rem;
    color: #555;
    max-width: 40rem;
  }
`;

export const ThemePanel = styled.div`
  background-color: #fafafa;
  border: 1px solid rgba(1, 1, 1, 0.08);
  border-radius: 12px;
  padding: 2rem;
  text-align: center;

  h2 {
    font-size: 1.7rem;
    text-transform: uppercase;
    font-weight: bold;
    word-break: break-word;
  }

  .subtitulo {
    font-size: 1.3rem;
    margin-top: 0.8rem;
    color: #555;
  }
`;

export const SeloImagesWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.2rem;
  margin-bottom: 1.6rem;
`;

export const SeloImage = styled.img`
  display: block;
  max-width: 7rem;
  max-height: 7rem;
`;

export const FormCard = styled.div`
  background-color: #fff;
  border: 1px solid rgba(1, 1, 1, 0.08);
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(1, 1, 1, 0.08);
  padding: 2.4rem;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  position: relative;

  @media ${devices.mobileL} {
    padding: 2rem 1.6rem;
    border-radius: 12px;
  }
`;

export const FormCardHeader = styled.div`
  text-align: center;

  h1 {
    font-size: 2rem;
    font-weight: 800;
    text-transform: uppercase;
  }

  p {
    font-size: 1.3rem;
    color: #555;
    margin-top: 0.4rem;
  }
`;

const pulse = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.03); }
  100% { transform: scale(1); }
`;

export const TrialBadge = styled.p`
  color: #107c41;
  background: #e8f8ee;
  border: 1px solid #b6e8c8;
  padding: 0.9rem 1.2rem;
  border-radius: 10px;
  font-weight: 600;
  text-align: center;
  font-size: 1.2rem;
  animation: ${pulse} 2.5s infinite;

  .no-card {
    display: block;
    font-weight: 400;
    font-size: 1.1rem;
    margin-top: 0.2rem;
  }
`;

export const GoogleButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const OrDivider = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  color: #999;
  font-size: 1.2rem;

  &::before,
  &::after {
    content: "";
    flex: 1;
    height: 1px;
    background-color: rgba(1, 1, 1, 0.1);
  }
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;

  label {
    font-size: 1.2rem;
    font-weight: 600;
    color: #333;
  }
`;

export const StyledInput = styled(Input)`
  width: 100%;
  height: 4.8rem;
  font-size: 1.5rem;

  ${({ $hasError }) =>
    $hasError &&
    css`
      border-color: #b91c1c;
    `}
`;

export const PasswordFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.2rem;
`;

export const FooterNote = styled.p`
  text-align: center;
  font-size: 1.1rem;
  color: #999;
  margin-top: 2.4rem;
`;
